import { commonCreateArticleFields } from "../../../articles/components/articleForm";

export default {
  ...commonCreateArticleFields({ allowDecimals: false }),
  "breakBulk.weight": {
    defaultValue: null,
    error: weight => !isNaN(weight) && parseFloat(weight) <= 0,
    convert: value => parseFloat(value)
  }
};
